<template>
  <div class="back-to-top" v-show="visible" @click="scrollToTop">
    <i class="el-icon-arrow-up"></i>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 300
    },
    backPosition: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      visible: false,
      interval: null,
      isAnimating: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
    },
    scrollToTop() {
      if (this.isAnimating) return
      this.isAnimating = true
      
      const startTime = Date.now()
      const startPosition = window.pageYOffset
      const distance = this.backPosition - startPosition
      
      this.interval = setInterval(() => {
        const now = Date.now()
        const elapsed = now - startTime
        
        if (elapsed >= this.duration) {
          window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
          this.isAnimating = false
          return
        }
        
        // 使用缓动函数使滚动更平滑
        const progress = elapsed / this.duration
        const easeInOutQuad = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
        const position = startPosition + distance * easeInOutQuad(progress)
        
        window.scrollTo(0, position)
      }, 16) // 约60fps
    }
  }
}
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #7e57c2;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 99;
  transition: all 0.3s ease;
  opacity: 0.8;
}

.back-to-top:hover {
  background-color: #6a4caf;
  transform: scale(1.1);
  opacity: 1;
}
</style> 